<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else class="text-normal">
      <h4 class="mb-3 header-tablepage">
        {{ id == "2" ? "Company Customer" : "Personal Customer" }}
      </h4>
      <b-row>
        <b-col sm="3" class="">
          <div class="header-secondary title-tabs header-title py-3">
            <b>Question List</b>
            <b-button class="add-btn" @click="addQuestion">
              <b-icon icon="plus-square" class="mr-2"></b-icon
              ><span>Create New</span></b-button
            >
          </div>
        </b-col>
        <b-col sm="9" class="">
          <div
            class="header-secondary title-tabs header-title d-none d-sm-block py-3"
          >
            <b>Detail</b>
          </div>
        </b-col>
      </b-row>

      <b-row class="bg-grey">
        <b-col sm="3" class="">
          <template v-for="(field, index) of requiredField">
            <div
              class="p-2 question-panel shadow-sm overflow-auto"
              @click="handleClickActive(false, index)"
              :key="field + index"
            >
              <div
                :class="[
                  'mt-2 p-3 question-card pointer',
                  !activeAddition && activeIndex == index && 'active',
                ]"
              >
                <div class="d-flex align-items-center" style="flex-flow: wrap">
                  <span class="mr-2 text-black font-weight-bold"
                    >Required Field :</span
                  >
                  <div class="mr-2 type-box">{{ field }}</div>
                  <span style="word-break: break-all"></span>
                </div>
                <div class="mt-1">
                  <p class="mb-1 text-light-grey text-truncate">
                    {{ questionDetailText(index) }}
                  </p>
                </div>
              </div>
            </div>
          </template>

          <draggable :list="additionnalQuestion" @end="changeDrag">
            <div
              class="p-2 question-panel shadow-sm overflow-auto"
              v-for="(addQues, index) of additionnalQuestion"
              :key="'add-' + index"
              @click="handleClickActive(true, index)"
            >
              <div
                :class="[
                  'mt-2 p-3 question-card pointer',
                  activeAddition && index == activeIndex && 'active',
                ]"
              >
                <div class="d-flex align-items-center" style="flex-flow: wrap">
                  <span class="mr-2 text-black font-weight-bold"
                    >Question {{ index + 1 }} :</span
                  >
                  <div class="mr-2 type-box">
                    {{ questionTypeText(addQues.field_type_id) }}
                  </div>
                  <span style="word-break: break-all"></span>
                </div>
                <div class="mt-1">
                  <p class="mb-1 text-light-grey text-truncate">
                    {{
                      addQues.field_language.length > 0
                        ? addQues.field_language[0].name
                        : addQues.name
                    }}
                  </p>
                </div>
              </div>
            </div>
          </draggable>
        </b-col>
        <b-col sm="9" class="">
          <div class="header-secondary title-tabs d-block d-sm-none">
            <span>Detail</span>
          </div>
          <div class="pt-2 bg-white text-normal shadow-sm">
            <div
              v-if="!activeAddition && [0, 1, 2].includes(activeIndex)"
              :set="
                (customerField =
                  activeIndex == 0
                    ? questionList.filter(
                        (el) => ![28, 2].includes(el.field_profile_type_id)
                      )
                    : activeIndex == 1
                    ? addressList
                    : socialField)
              "
            >
              <b-row class="px-3">
                <b-col sm="1">
                  <div class="text-center font-bold text-nowrap">
                    Sort Order
                  </div>
                </b-col>
                <b-col sm="1">
                  <div class="font-bold text-center">Required</div>
                </b-col>
                <b-col sm="2">
                  <div class="font-bold">Field Name</div>
                </b-col>
                <b-col sm="2">
                  <div class="font-bold">Description</div>
                </b-col>
                <b-col sm="2">
                  <div class="font-bold text-center">Dependent Field</div>
                </b-col>
                <b-col sm="2">
                  <div class="font-bold text-center">Display</div>
                </b-col>
                <b-col sm="2">
                  <div class="font-bold text-center">
                    Display in Edit Profile
                  </div>
                </b-col>
                <template v-for="(profile, index) in customerField">
                  <template v-if="profile.field_profile_type_id == 27">
                    <b-col sm="1" :key="'sort-' + index">
                      <div class="content-between mt-3">
                        <font-awesome-icon
                          icon="chevron-circle-up"
                          @click="
                            switchProfileIndex(
                              profile,
                              index,
                              false,
                              activeIndex
                            )
                          "
                          :class="`icon-size ${
                            index == 0 || activeIndex == 1
                              ? 'disabled'
                              : 'pointer'
                          }`"
                        />
                        {{ index + 1 }}
                        <font-awesome-icon
                          icon="chevron-circle-down"
                          @click="
                            switchProfileIndex(
                              profile,
                              index,
                              true,
                              activeIndex
                            )
                          "
                          :class="`icon-size ${
                            index == questionList.length - 1 || activeIndex == 1
                              ? 'disabled'
                              : 'pointer'
                          }`"
                        />
                      </div>
                    </b-col>
                    <b-col
                      sm="1"
                      class="text-center"
                      :key="'required-' + index"
                    >
                      <b-form-checkbox
                        class="disableCheckbox mt-3 mb-1"
                        :id="`checkbox-profile-${index}`"
                        :name="`checkbox-profile-${index}`"
                        v-model="profile.required"
                        :disabled="disabledField(profile)"
                        @change="handleCheckRequired($event, profile)"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col sm="2" :class="'flex-auto'" :key="'name-' + index">
                      <!-- <div v-else> -->
                      <template>
                        <InputText
                          v-if="!isLoading"
                          textFloat=""
                          disabled
                          v-model="profile.profile_name"
                          :placeholder="profile.profile_name"
                          class="margin-input"
                          type="text"
                        />
                        <template v-for="choice of profile.field_choices">
                          <div class="pl-2" :key="choice.id">
                            <InputText
                              v-if="!isLoading"
                              textFloat=""
                              disabled
                              v-model="choice.name"
                              :placeholder="choice.name"
                              @input="() => (choice.is_update = 1)"
                              class="margin-input"
                              type="text"
                            />
                            <template v-for="sub_choice of choice.denpendent">
                              <div :key="sub_choice.id" class="pl-3">
                                <InputText
                                  v-if="!isLoading"
                                  textFloat=""
                                  disabled
                                  v-model="sub_choice.choice_dependent_name"
                                  :placeholder="
                                    sub_choice.choice_dependent_name
                                  "
                                  class="margin-input"
                                  type="text"
                                />
                              </div>
                            </template>
                          </div>
                        </template>
                      </template>

                      <!-- </div> -->
                    </b-col>
                    <b-col sm="2" :class="'flex-auto'" :key="'desc-' + index">
                      <InputText
                        v-if="!isLoading"
                        textFloat=""
                        v-model="profile.profile_name"
                        :placeholder="profile.profile_name"
                        class="margin-input"
                        type="text"
                      />
                      <template v-for="choice of profile.field_choices">
                        <div :key="choice.id">
                          <InputText
                            v-if="!isLoading"
                            textFloat=""
                            v-model="choice.description"
                            :placeholder="choice.description"
                            class="margin-input"
                            type="text"
                          />

                          <template v-for="sub_choice of choice.denpendent">
                            <div :key="sub_choice.id">
                              <InputText
                                v-if="!isLoading"
                                textFloat=""
                                v-model="sub_choice.name"
                                @input="() => (sub_choice.is_update = 1)"
                                :placeholder="sub_choice.name"
                                class="margin-input"
                                type="text"
                              />
                            </div>
                          </template>
                        </div>
                      </template>
                    </b-col>
                    <b-col
                      sm="2"
                      class="text-center"
                      :key="'dependent-' + index"
                    >
                      <div>
                        <template
                          v-for="(choice, c_index) of profile.field_choices"
                        >
                          <div :key="choice.id">
                            <div
                              class="space-dependent d-block"
                              :style="c_index == 0 ? 'margin-top:5px' : ''"
                            ></div>
                            <div
                              class="space-dependent d-block"
                              v-if="c_index == 0"
                            ></div>
                            <template v-for="sub_choice of choice.denpendent">
                              <div
                                class="space-dependent cursor-pointer"
                                :key="sub_choice.id"
                              >
                                <font-awesome-icon
                                  @click="
                                    editChoice(
                                      sub_choice,
                                      profile.field_profile_type_id
                                    )
                                  "
                                  icon="pencil-alt"
                                  title="Edit"
                                />
                              </div>
                            </template>
                          </div>
                        </template>
                      </div>
                    </b-col>
                    <b-col sm="2" class="text-center" :key="'display-' + index">
                      <b-form-checkbox
                        class="disableCheckbox mt-3 mb-1"
                        :id="`checkbox-company-is-show-${index}`"
                        :name="`checkbox-company-is-show-${index}`"
                        v-model="profile.is_show"
                        :value="1"
                        :unchecked-value="0"
                        :disabled="profile.required || disabledField(profile)"
                        @change="handleDisplay($event, profile)"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      sm="2"
                      :class="'flex-auto text-center'"
                      :key="'display-edit-' + index"
                    >
                      <b-form-checkbox
                        class="disableCheckbox mt-3 mb-1"
                        :id="`checkbox-profile-edit-is-show-${index}`"
                        :name="`checkbox-profile-edit-is-show-${index}`"
                        v-model="profile.show_on_edit_profile"
                        :value="1"
                        :unchecked-value="0"
                        :disabled="profile.required || disabledField(profile)"
                        @change="handleDisplay($event, profile)"
                      >
                      </b-form-checkbox>
                    </b-col>
                  </template>

                  <template
                    v-else-if="![28, 2].includes(profile.field_profile_type_id)"
                  >
                    <b-col sm="1" :key="'sort-' + index">
                      <div class="content-between mt-3">
                        <font-awesome-icon
                          icon="chevron-circle-up"
                          @click="
                            switchProfileIndex(
                              profile,
                              index,
                              false,
                              activeIndex
                            )
                          "
                          :class="`icon-size ${
                            index == 0 || activeIndex == 1
                              ? 'disabled'
                              : 'pointer'
                          }`"
                        />
                        {{ index + 1 }}
                        <font-awesome-icon
                          icon="chevron-circle-down"
                          @click="
                            switchProfileIndex(
                              profile,
                              index,
                              true,
                              activeIndex
                            )
                          "
                          :class="`icon-size ${
                            index == questionList.length - 1 || activeIndex == 1
                              ? 'disabled'
                              : 'pointer'
                          }`"
                        />
                      </div>
                    </b-col>
                    <b-col
                      sm="1"
                      class="text-center"
                      :key="'required-' + index"
                    >
                      <b-form-checkbox
                        class="disableCheckbox mt-3 mb-1"
                        :id="`checkbox-profile-${index}`"
                        :name="`checkbox-profile-${index}`"
                        v-model="profile.required"
                        :disabled="disabledField(profile)"
                        @change="handleCheckRequired($event, profile)"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col sm="2" :class="'flex-auto'" :key="'name-' + index">
                      <div>
                        <InputText
                          v-if="!isLoading"
                          textFloat=""
                          disabled
                          v-model="profile.profile_name"
                          :placeholder="profile.profile_name"
                          class="margin-input"
                          type="text"
                        />
                      </div>
                    </b-col>
                    <b-col sm="2" :class="'flex-auto'" :key="'desc-' + index">
                      <!-- -->

                      <template v-if="profile.field_language.length > 0">
                        <InputText
                          v-if="!isLoading"
                          textFloat=""
                          class="margin-input"
                          type="text"
                          @input="(val) => (profile.name = val)"
                          v-model="profile.field_language[languageIndex].name"
                          :placeholder="
                            profile.field_language[languageIndex].name
                          "
                        />
                      </template>
                      <template v-else>
                        <InputText
                          v-if="!isLoading"
                          textFloat=""
                          class="margin-input"
                          type="text"
                          v-model="profile.name"
                          :placeholder="profile.name"
                        />
                      </template>
                    </b-col>
                    <b-col
                      sm="2"
                      class="text-center"
                      :key="'dependent-' + index"
                    >
                    </b-col>
                    <b-col sm="2" class="text-center" :key="'display-' + index">
                      <b-form-checkbox
                        class="disableCheckbox mt-3 mb-1"
                        :id="`checkbox-company-is-show-${index}`"
                        :name="`checkbox-company-is-show-${index}`"
                        v-model="profile.is_show"
                        :value="1"
                        :unchecked-value="0"
                        :disabled="profile.required || disabledField(profile)"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      sm="2"
                      :class="'flex-auto text-center'"
                      :key="'display-edit-' + index"
                    >
                      <b-form-checkbox
                        class="disableCheckbox mt-3 mb-1"
                        :id="`checkbox-profile-edit-is-show-${index}`"
                        :name="`checkbox-profile-edit-is-show-${index}`"
                        v-model="profile.show_on_edit_profile"
                        :value="1"
                        :unchecked-value="0"
                        @input="(val) => onInput(val, profile)"
                        :disabled="profile.required || disabledField(profile)"
                      >
                      </b-form-checkbox>
                    </b-col>
                  </template>
                </template>
              </b-row>
            </div>
            <div v-else class="p-3">
              <div>
                <b-form-checkbox
                  v-model="additionnalQuestion[activeIndex].is_show"
                  :checked="additionnalQuestion[activeIndex].is_show"
                  :value="1"
                  :unchecked-value="0"
                  @change="
                    $event == 0 &&
                    additionnalQuestion[activeIndex].show_on_edit_profile == 0
                      ? (additionnalQuestion[activeIndex].required = false)
                      : undefined
                  "
                  >Show on Register Form</b-form-checkbox
                >
              </div>
              <div class="content-between">
                <div>
                  <b-form-checkbox
                    v-model="
                      additionnalQuestion[activeIndex].show_on_edit_profile
                    "
                    :checked="
                      additionnalQuestion[activeIndex].show_on_edit_profile
                    "
                    :value="1"
                    :unchecked-value="0"
                    @change="
                      $event == 0 &&
                      additionnalQuestion[activeIndex].is_show == 0
                        ? (additionnalQuestion[activeIndex].required = false)
                        : undefined
                    "
                    >Show on Edit Profile</b-form-checkbox
                  >
                </div>
                <div class="d-flex justify-content-end align-items-center">
                  <label class="mb-0 mr-2">Required</label>
                  <b-form-checkbox
                    class="mb-1 mr-2"
                    size="lg"
                    v-model="additionnalQuestion[activeIndex].required"
                    :disabled="
                      typeHidden(
                        additionnalQuestion[activeIndex].field_type_id
                      ) ||
                      (!additionnalQuestion[activeIndex].is_show &&
                        !additionnalQuestion[activeIndex].show_on_edit_profile)
                    "
                    switch
                  >
                  </b-form-checkbox>
                  <b-icon
                    size="lg"
                    icon="trash-fill"
                    class="icon-size pointer"
                    @click="deleteQuestion"
                  />
                </div>
              </div>
              <div class="mt-3 w-25">
                <b-form-select
                  v-model="additionnalQuestion[activeIndex].field_type_id"
                  :options="fieldTypes"
                  @change="changeQeustionType"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div>
              <div class="mt-3">
                <div
                  v-if="
                    !(
                      additionnalQuestion[activeIndex].field_type_id == 10 ||
                      additionnalQuestion[activeIndex].field_type_id == 11 ||
                      additionnalQuestion[activeIndex].field_type_id == 13 ||
                      additionnalQuestion[activeIndex].field_type_id == 14
                    )
                  "
                >
                  <InputText
                    class="text-float-normal w-50"
                    textFloat="Validate Text"
                    v-model="additionnalQuestion[activeIndex].validate_text"
                    :placeholder="
                      additionnalQuestion[activeIndex].validate_text
                    "
                    :disabled="
                      additionnalQuestion[activeIndex].field_type_id == 10 ||
                      additionnalQuestion[activeIndex].field_type_id == 11 ||
                      additionnalQuestion[activeIndex].field_type_id == 13 ||
                      additionnalQuestion[activeIndex].field_type_id == 14
                    "
                    type="text"
                  />
                </div>
                <div
                  v-if="
                    !(
                      additionnalQuestion[activeIndex].field_type_id == 9 ||
                      additionnalQuestion[activeIndex].field_type_id == 13 ||
                      additionnalQuestion[activeIndex].field_type_id == 14
                    )
                  "
                >
                  <InputText
                    isRequired
                    :class="[
                      'text-float-normal question-name-input margin-input-5',
                      isSubmit && !additionnalQuestion[activeIndex].name
                        ? 'error'
                        : '',
                    ]"
                    textFloat="Question"
                    v-model="
                      additionnalQuestion[activeIndex].field_language[
                        languageIndex
                      ].name
                    "
                    :disabled="
                      additionnalQuestion[activeIndex].field_type_id == 9 ||
                      additionnalQuestion[activeIndex].field_type_id == 13 ||
                      additionnalQuestion[activeIndex].field_type_id == 14
                    "
                    :placeholder="
                      additionnalQuestion[activeIndex].field_language[
                        languageIndex
                      ].name
                    "
                    type="text"
                    :v="
                      $v.additionnalQuestion.$each.$iter[activeIndex]
                        .field_language.$each.$iter[languageIndex].name
                    "
                    @input="
                      (val) => (additionnalQuestion[activeIndex].name = val)
                    "
                  />
                </div>
              </div>
              <div class="my-3">
                <FieldTextDetail
                  v-if="additionnalQuestion[activeIndex].field_type_id == 1"
                  :questionList="additionnalQuestion"
                  :questionActive="activeIndex"
                />
                <FieldChoiceDetail
                  v-if="
                    additionnalQuestion[activeIndex].field_type_id >= 2 &&
                    additionnalQuestion[activeIndex].field_type_id <= 4
                  "
                  :questionList="additionnalQuestion"
                  :questionActive="activeIndex"
                />
                <DateInput
                  v-if="additionnalQuestion[activeIndex].field_type_id == 5"
                />

                <ModalSelectBranch
                  v-if="
                    additionnalQuestion[activeIndex].branchList &&
                    additionnalQuestion[activeIndex].branchList.length > 0 &&
                    additionnalQuestion[activeIndex].field_type_id == 6
                  "
                  :list="additionnalQuestion[activeIndex].branchList"
                  @selectBranch="selectBranch"
                  :field="additionnalQuestion[activeIndex]"
                  text="Select Branch"
                  id=""
                  :BranchSelectList="
                    additionnalQuestion[activeIndex].select_branch
                  "
                />
                <Date
                  v-if="additionnalQuestion[activeIndex].field_type_id == 7"
                  class=""
                />

                <InputTextArea
                  v-if="additionnalQuestion[activeIndex].field_type_id == 12"
                  textFloat=""
                  type="text"
                  class="mt-3 custom-input"
                  placeholder=""
                  rows="3"
                />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <FooterAction routePath="/setting" @submit="sendForm(0)" />
    <Sidebar
      :choiceDetail="choiceDetail"
      ref="sidebarDependent"
      @addDependent="addDependent"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Date from "@/components/form/preview/Date";
import DateInput from "@/components/form/preview/DateInput";
import ModalSelectBranch from "@/components/ModalSelectBranch";
import OtherLoading from "@/components/loading/OtherLoading";
import FieldChoiceDetail from "@/components/form/detail/FieldChoiceDetail";
import FieldTextDetail from "@/components/form/detail/FieldTextDetail";
import Sidebar from "./SidebarDepentdent";
import InputTextArea from "@/components/inputs/InputTextArea";
import Multiselect from "vue-multiselect";
import { required, email, requiredIf } from "vuelidate/lib/validators";
export default {
  props: {
    id: { required: true, type: Number },
  },
  components: {
    draggable,
    Date,
    DateInput,
    ModalSelectBranch,
    OtherLoading,
    FieldChoiceDetail,
    FieldTextDetail,
    Sidebar,
    InputTextArea,
    Multiselect,
  },
  validations() {
    return {
      additionnalQuestion: {
        $each: {
          field_language: {
            $each: {
              name: {
                required: requiredIf(function (item, val) {
                  return item.language_id == 1 &&
                    (item.field_type_id != 14 || item.field_type_id != 13)
                    ? true
                    : false;
                }),
              },
            },
          },
        },
      },
    };
  },
  data() {
    return {
      value: [],
      isLoading: true,
      isBusy: false,
      isSubmit: false,
      requiredField: [
        "Customer Information",
        "Address Information",
        "Social Information",
      ],
      questionList: [],
      socialField: [],
      addressList: [],
      activeIndex: 0,
      questionProfileIndex: null,
      showProfilePanel: true,
      additionnalQuestion: [],
      branchList: [],
      fieldTypes: [
        { id: 1, name: "Field" },
        { id: 2, name: "Checkbox" },
        { id: 3, name: "Multiple Choice" },
        { id: 4, name: "Dropdown" },
        { id: 5, name: "DateTime" },
        { id: 6, name: "Branch dropdown" },
        { id: 7, name: "Date" },
        { id: 8, name: "Image" },
        { id: 10, name: "Title" },
        { id: 11, name: "Subtitle" },
        { id: 12, name: "Text Area" },
        { id: 13, name: "Space" },
      ],
      activeAddition: false,
      activeIndex: 0,
      choiceDetail: {},
      isShow: false,
      languageIndex: 0,
    };
  },
  computed: {
    fieldList() {
      return this.activeIndex == 0
        ? this.questionList
            .filter((el) => ![28, 2].includes(el.field_profile_type_id))
            .map((el, index) => {
              return { ...el, sort_order: index };
            })
        : this.activeIndex == 1
        ? this.addressList
        : this.socialField;
    },
  },

  async created() {
    this.getField();
    this.getFieldType();
  },
  methods: {
    editChoice(sub_choice, main_id) {
      this.isShow = true;

      this.choiceDetail = { ...sub_choice, field_main_id: main_id };

      this.$nextTick(() => this.$refs.sidebarDependent.show());
    },
    addDependent(val) {
      let form = JSON.parse(JSON.stringify(this.questionList));
      let index = form.findIndex(
        (el) => el.field_profile_type_id == val.field_main_id
      );

      let choiceIndex = form[index].field_choices.findIndex(
        (el) => el.id == val.choice_main
      );
      let dependentIndex = form[index].field_choices[
        choiceIndex
      ].denpendent.findIndex(
        (el) => el.choice_dependent == val.choice_dependent
      );
      form[index].field_choices[choiceIndex].denpendent[dependentIndex] = val;
      this.$nextTick(() => (this.questionList = form));
    },

    async getFieldType() {
      await this.$store.dispatch("getFieldTypes");
      let data = this.$store.state.form.fieldtype;
      if (data.result == 1) {
        this.fieldTypes = data.detail.fieldTypes.filter((type) => type.id != 9);
      }
    },
    addTag(newTag) {
      let quesPrefix = this.questionList.find(
        (el) => el.field_profile_type_id == 2
      );
      quesPrefix.field_choices.map((el) => {
        if (newTag.findIndex((els) => el.id == els.id) != -1) {
          el.is_display = 1;
          el.check = 2;
        } else {
          el.is_display = 0;
        }
      });
    },
    async getField() {
      let url = `/setting/getregisterform`;
      if (this.id == 2) url = `/setting/getcompanyform`;
      const { data } = await this.axios(url);
      let quesPrefix = data.detail.profileField.find(
        (el) => el.field_profile_type_id == 2
      );

      this.value =
        quesPrefix &&
        quesPrefix.field_choices.filter((el) => el.is_display == 1);
      data.detail.profileField.map((el) =>
        el.required ? (el.is_show = 1) : false
      );
      for (const field of data.detail.customField) {
        if (field.field_type_id === 6) {
          // this.isLoading = true;
          await this.getBranchList(field, field.branch_group_id);
          field.select_branch = field.select_branch || [];
        }
      }

      this.additionnalQuestion = data.detail.customField;
      data.detail.profileField = data.detail.profileField.map((el) => {
        if (el.field_language.length == 0)
          return {
            ...el,
            field_language: [
              {
                id: 0,
                language_id: 1,
                field_id: el.id,
                name: el.name,
              },
            ],
          };
        else {
          return { ...el };
        }
      });
      // data.detail.profileField = data.detail.profileField.map((el) => {
      //   if (el.id == 28) {
      //     return { ...el, display: false };
      //   }
      // });
      this.questionList = data.detail.profileField.filter(
        (el) => el.group_id == 1
      );
      this.socialField = data.detail.socialField.map((el) => {
        return { ...el, is_social: true };
      });
      this.addressList = data.detail.profileField.filter(
        (el) => el.group_id == 2
      );

      this.isLoading = false;
    },
    handleCheckRequired(val, items) {
      let grouped = [2, 28];

      if (val) {
        if (items.field_profile_type_id == 27) {
          for (const f_id of grouped) {
            let index = this.questionList.findIndex(
              (el) => el.field_profile_type_id == f_id
            );
            this.questionList[index] = {
              ...this.questionList[index],
              is_show: 1,
              required: 1,
              show_on_edit_profile: 1,
            };
          }
        }
      } else {
        if (items.field_profile_type_id == 27) {
          for (const f_id of grouped) {
            let index = this.questionList.findIndex(
              (el) => el.field_profile_type_id == f_id
            );
            this.questionList[index] = {
              ...this.questionList[index],
              required: 0,
            };
          }
        }
      }
      this.$nextTick(
        () => (items.is_show = 1),
        (items.show_on_edit_profile = 1)
      );
    },
    disabledField(items) {
      if (
        items.field_profile_type_id == 22 ||
        items.field_profile_type_id == 27 ||
        items.field_profile_type_id == 29 ||
        items.field_profile_type_id == 3 ||
        items.field_profile_type_id == 10
      ) {
        return true;
      }
      if (items.is_profile_required) {
        return true;
      }
      if (this.isRegister) {
        return true;
      }
      return false;
    },
    handleDisplay(val, items) {
      let grouped = [2, 28];
      if (items.field_profile_type_id == 27) {
        for (const f_id of grouped) {
          let index = this.questionList.findIndex(
            (el) => el.field_profile_type_id == f_id
          );
          this.questionList[index] = {
            ...this.questionList[index],
            is_show: val,
            show_on_edit_profile: val,
          };
        }
      }
    },
    async switchProfileIndex(items, index, val, activeIndex) {
      if (activeIndex == 1) return;
      let list = ["questionList", "addressList", "socialField"];
      // let fieldsFilter = JSON.parse(JSON.stringify(this[list[activeIndex]]));
      let cloneFields = this[list[activeIndex]].filter(
        (el) => ![28, 2].includes(el.id)
      );

      if (index == 0 && !val) {
        return;
      }
      // fieldsFilter.splice(index, 1);
      cloneFields.splice(index, 1);

      index = val ? index + 1 : index - 1;

      // fieldsFilter.splice(index, 0, items);
      cloneFields.splice(index, 0, items);
      let index27 = cloneFields.findIndex((el) => el.id == 27);
      let index28 = this[list[activeIndex]].findIndex((el) => el.id == 28);
      let index2 = this[list[activeIndex]].findIndex((el) => el.id == 2);
      cloneFields.splice(index27 + 1, 0, {
        ...this[list[activeIndex]][index28],
        use: true,
      });
      cloneFields.splice(index27 + 2, 0, {
        ...this[list[activeIndex]][index2],
        use: true,
      });

      var index = 0;
      for (const fields of cloneFields) {
        fields.sort_order = index;
        index++;
      }
      this.$nextTick(() => {
        this[list[activeIndex]] = [...cloneFields];
        // this.sortArray();
      });
    },

    questionDetailText(index) {
      if (index == 0) {
        const text = this.questionList
          .filter((el) => el.is_show || el.show_on_edit_profile)
          .map((els) => els.name)
          .join(",");
        return text;
      }
      if (index == 1) {
        const text = this.addressList
          .filter((el) => el.is_show || el.show_on_edit_profile)
          .map((els) => els.name)
          .join(",");
        return text;
      }
      if (index == 2) {
        const text = this.socialField
          .filter((el) => el.is_show || el.show_on_edit_profile)
          .map((els) => els.name)
          .join(",");
        return text;
      }
    },
    questionTypeText(type) {
      if (type != undefined)
        if (type == 0) {
          return "Customer Detail";
        } else {
          let index = this.fieldTypes.findIndex((field) => field.id == type);
          return this.fieldTypes[index].name;
        }
    },
    addQuestion() {
      this.additionnalQuestion.push({
        field_type_id: 1,
        required: false,
        img: "",
        name: "",
        is_show: 1,
        field_profile_type_id: 0,
        select_branch: [],
        field_choices: [],
        field_conditions: [
          { field_condition_type_id: 1, value: "text" },
          { field_condition_type_id: 2, value: "" },
          { field_condition_type_id: 3, value: "" },
          { field_condition_type_id: 4, value: "" },
        ],
        validate_text: this.defaultValidateText(1),
        field_language: [
          {
            id: 0,
            language_id: 1,
            name: "",
            description: "",
          },
        ],
        show_on_edit_profile: 0,
      });
      this.activeIndex = this.additionnalQuestion.length - 1;
      this.activeAddition = true;
    },
    async sendForm() {
      var nameList = ["นาย", "นาง", "นางสาว"];
      for (const fields of this.questionList) {
        switch (fields.field_profile_type_id) {
          case 2:
            if (fields.field_choices.every((el) => el.is_display == 0)) {
              fields.field_choices.map((el) => {
                if (nameList.includes(el.name)) el.is_display = 1;
              });
            }

            break;
          case 9:
            fields.field_conditions.map((el) => {
              if (el.field_condition_type_id == 3) {
                el.value = el.value == "" ? "1753-01-01" : el.value;
              } else if (el.field_condition_type_id == 4) {
                el.value =
                  el.value == ""
                    ? this.$moment().format("YYYY-MM-DD")
                    : el.value;
              }
            });

          default:
            break;
        }
      }
      this.$v.additionnalQuestion.$touch();
      if (this.$v.additionnalQuestion.$error) {
        return;
      }
      let profileField = JSON.parse(JSON.stringify(this.questionList));

      profileField = profileField.map((el, index) => {
        return { ...el, sort_order: index };
      });

      let payload = {
        custom_form: this.additionnalQuestion,
        profile_form: [...profileField, ...this.addressList],
        social_form: this.socialField,
      };
      this.$bus.$emit("showLoading");
      let url = "/setting/updateregisterform";
      if (this.id == 2) url = "/setting/updatecompanyform";
      const { data } = await this.axios.put(url, payload);

      this.$bus.$emit("hideLoading");
      if (data.result == 1) {
        this.isLoading = false;

        this.successAlert().then(() => {
          this.$router.push("/setting/company");
        });
      } else {
        this.isLoading = false;
        this.errorAlert(data.message);
      }
    },
    typeHidden(type) {
      if (type == 9 || type == 10 || type == 11 || type == 13 || type == 14) {
        return true;
      } else {
        return false;
      }
    },
    handleClickActive(val, index) {
      this.activeAddition = val;
      this.activeIndex = index;
    },
    deleteQuestion() {
      this.additionnalQuestion.splice(this.activeIndex, 1);
      if (this.additionnalQuestion.length == 0) {
        this.activeAddition = 0;
        this.activeIndex = 0;
      } else {
        this.activeIndex = this.activeIndex;
      }
    },
    async getBranchList(field, id) {
      await this.$store.dispatch("getBranch", parseInt(id));
      field.branchList = this.$store.state.coupon.branchList.detail;
      this.branchList = this.$store.state.coupon.branchList.detail;
    },
    changeDrag(value) {
      if (this.activeAddition) this.activeIndex = value.newIndex;
    },
    async changeQeustionType(value) {
      if (value == 1) {
        this.additionnalQuestion[this.activeIndex].field_conditions = [
          { field_condition_type_id: 1, value: "text" },
          { field_condition_type_id: 2, value: "" },
          { field_condition_type_id: 3, value: "" },
          { field_condition_type_id: 4, value: "" },
        ];
        this.additionnalQuestion[this.activeIndex].field_choices = [];
      } else if (value >= 2 && value <= 4) {
        this.additionnalQuestion[this.activeIndex].field_conditions = [];
        this.additionnalQuestion[this.activeIndex].field_choices = [
          { name: "choice 1", sort_order: 0, isDefault: 0 },
        ];
      } else if (value == 5 || value == 7) {
        this.additionnalQuestion[this.activeIndex].field_conditions = [];
        this.additionnalQuestion[this.activeIndex].field_choices = [
          { name: "" },
        ];
      } else if (value == 6) {
        this.additionnalQuestion[this.activeIndex].field_choices = [];
        this.additionnalQuestion[this.activeIndex].field_conditions = [];
        let idBranch = 0;
        if (this.additionnalQuestion[this.activeIndex].branch_group_id) {
          idBranch = this.additionnalQuestion[this.activeIndex].branch_group_id;
        }
        // this.isLoading = true;
        await this.getBranchList(
          this.additionnalQuestion[this.activeIndex],
          idBranch
        );
      } else {
        this.additionnalQuestion[this.activeIndex].field_conditions = [];
        this.additionnalQuestion[this.activeIndex].field_choices = [];
      }
      if (value != 6) {
        delete this.additionnalQuestion[this.activeIndex].branchList;
      }
      if (this.typeHidden(value)) {
        this.additionnalQuestion[this.activeIndex].required = false;
        this.additionnalQuestion[this.activeIndex].name = "";
      }
      this.additionnalQuestion[this.activeIndex].validate_text =
        this.defaultValidateText(value);
    },
    defaultValidateText(type) {
      if (type >= 2 && type <= 4) {
        return "Please select choice.";
      } else if (type == 5 || type == 7) {
        return "Please enter date.";
      } else if (type == 6) {
        return "Please select branch.";
      } else if (type == 8) {
        return "Please input image.";
      } else if (type == 10 || type == 11 || type == 13 || type == 14) {
        return "";
      } else {
        return "Please input text.";
      }
    },
    selectBranch(value) {
      this.additionnalQuestion[this.activeIndex].select_branch = value;
      this.$forceUpdate();
    },
    onInput(val, profile) {
      console.log(val);
      profile.show_on_edit_profile = val;
      this.$nextTick();
    },
  },
};
</script>

<style lang="scss" scoped>
.text-normal {
  color: #5b5b5b;
}
.text-light-grey {
  color: #9a9a9a;
}
::v-deep .text-float-normal .input-custom {
  label {
    color: #5b5b5b;
    font-size: 16px;
    font-weight: 100;
  }
}
.header-title {
  height: 100%;
  padding: 8px 16px;
  margin-top: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-btn {
  color: white;
  background-color: var(--primary-color);
  display: flex;
  justify-content: center;
  align-items: center;
  border: none !important;
}
.add-btn:hover {
  background-color: var(--primary-color);
}
.question-panel {
  max-height: 50vh;
  background-color: white;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 10px;
}

.question-card {
  box-shadow: 0px 0px 7px -1px rgba(0, 0, 0, 0.24);

  border-left: 5px solid transparent;
  background-color: white;
  border-radius: 4px;
  text-overflow: ellipsis;
}
.question-card.active {
  border-left: 5px solid var(--primary-color);
}
.type-box {
  padding: 2px 8px;
  color: var(--primary-color);
  background-color: var(--theme-secondary-color);
  border-radius: 6px;
}
.icon-size {
  font-size: 20px;
  color: #575757;
}
.icon-size.disabled {
  color: #bababa;
}
#footer {
  position: fixed;
  bottom: 0;
  left: 256px;
  right: 0;
  height: 10%;
  padding: 15px;
  background: #fff;
}
.margin-input {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.margin-input-5 {
  margin-bottom: 5px !important;
}
::v-deep .question-name-input.error {
  input {
    border: 1px solid red;
  }
}
.dropdown-input-field ::v-deep button {
  overflow: hidden;
  color: var(--font-main-color);
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
  height: calc(1.5em + 0.75rem + 2px);
  text-align: left;
  padding: 0.375rem 0.75rem;
  background: white;
}
::v-deep .multiselect__single {
  font-size: 14px !important;
}
.space-dependent {
  height: 35px;
  width: 100%;
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  // background: red;
  &.main {
    margin-top: 8px;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
